export const accountingI18n = {
  accounting: {
    en: {
      ACCOUNTING_BASES: 'Accounting bases',
      ADD: 'Add',
      ADD_NEW: 'Add new',
      APPROVED: 'Approved',
      APPROVED_BY: 'Approved by {{name}}',
      ARE_YOU_SURE_WANT_TO_CHANGE: 'Are you sure want to change?',
      ARE_YOU_SURE_WANT_TO_DELETE: 'Are you sure want to delete?',
      BANK: 'Bank',
      BANK_ACCOUNT_NUMBER: 'Bank account number',
      BASIS: 'Accounting basis',
      BUSINESS_ENTITY: 'Business entity',
      COMMENT: 'Comment',
      COMPANY_NOTES: 'Company notes',
      CONFIRM: 'Confirm',
      COST_REIMBURSEMENT_PER_MONTH: 'Cost reimbursement per month',
      CREATE: 'Create',
      CREATE_FAILED: 'Create failed',
      CREATE_NEW_SCHEDULE: 'Create new schedule',
      CREATED_BY: 'Created by {{name}}',
      CREATED_DATE: 'Created date',
      CREATED_SUCCESSFULLY: 'Created successfully',
      CURRENT_USER_NOTES: 'My notes',
      DATE: 'Date',
      DELETE: 'Delete',
      DELETE_FAILED: 'Delete failed',
      DELETED_SUCCESSFULLY: 'Deleted successfully',
      EMPLOYEE: 'Employee',
      EMPLOYEE_BASES: 'Employee bases',
      FILTER: 'Filter',
      FILTER_NOTES_DESCRIPTION:
        'Filter by specified criteria to find what you are looking for.',
      FRAMEWORK_AGREEMENT: 'Framework agreement',
      GROSS_SALARY: 'Gross salary',
      INVOICE: 'Invoice',
      INVOICE_ADDRESS: 'Invoice address',
      MUNICIPALITY: 'Municipality',
      NAME: 'Name',
      NO: 'No',
      NOT_APPROVED: 'Not approved',
      NOTES: 'Notes',
      NOTHING_TO_SHOW: 'There is nothing to show',
      PAYMENT_DATE: 'Payment date',
      PAYROLL_SCHEDULE: 'Payroll schedule',
      PAYROLL_SCHEDULES: 'Payroll schedules',
      PLACEMENT_INVOICE: 'Invoice',
      PLACEMENT_INVOICE_BASES: 'Placement invoice bases',
      PLACEMENT_SALARY: 'Salary',
      PLACEMENT_SALARY_BASES: 'Placement salary bases',
      SALARY: 'Salary',
      SALARY_PER_DAY: 'Care cost per day',
      SALARY_PER_MONTH: 'Salary per month',
      SOCIAL_REFERENCE_ID: 'Reference ID',
      TITLE: 'Title',
      TYPE: 'Type',
      UPDATE_FAILED: 'Update failed',
      UPDATED_SUCCESSFULLY: 'Updated',
      YES: 'Yes',
      YOUR_CHANGES_WILL_BE_IRREVERSIBLE:
        'Your changes will be irreversible and cannot be undone',
      YOUR_CHANGES_WILL_BE_IRREVERSIBLE_AND_NEED_APPROVAL:
        'Your changes will be irreversible and will require a new approval',
    },
    'sv-SE': {
      ACCOUNTING_BASES: 'Bokföringsunderlag',
      ADD: 'Lägg till',
      ADD_NEW: 'Lägg till ny',
      APPROVED: 'Godkänd',
      APPROVED_BY: 'Godkänd av {{name}}',
      ARE_YOU_SURE_WANT_TO_CHANGE: 'Är du säker på att du vill ändra?',
      ARE_YOU_SURE_WANT_TO_DELETE: 'Är du säker på att du vill radera?',
      BANK: 'Bank',
      BANK_ACCOUNT_NUMBER: 'Bankkontonummer',
      BASIS: 'Bokföringsunderlag',
      BUSINESS_ENTITY: 'Affärsenhet',
      COMMENT: 'Kommentar',
      COMPANY_NOTES: 'Företagskommentarer',
      CONFIRM: 'Bekräfta',
      COST_REIMBURSEMENT_PER_MONTH: 'Omställningsersättning per månad',
      CREATE: 'Skapa',
      CREATE_FAILED: 'Skapandet misslyckades',
      CREATE_NEW_SCHEDULE: 'Skapa nytt schema',
      CREATED_BY: 'Skapad av {{name}}',
      CREATED_DATE: 'Skapelsedatum',
      CREATED_SUCCESSFULLY: 'Skapad framgångsrikt',
      CURRENT_USER_NOTES: 'Mina kommentarer',
      DATE: 'Datum',
      DELETE: 'Radera',
      DELETE_FAILED: 'Raderingen misslyckades',
      DELETED_SUCCESSFULLY: 'Raderad framgångsrikt',
      EMPLOYEE: 'Anställd',
      EMPLOYEE_BASES: 'Underlag för anställd',
      FILTER: 'Filtrera',
      FILTER_NOTES_DESCRIPTION:
        'Filtrera efter angivna kriterier för att hitta det du letar efter.',
      FRAMEWORK_AGREEMENT: 'Ramavtal',
      GROSS_SALARY: 'Bruttolön',
      INVOICE: 'Faktura',
      INVOICE_ADDRESS: 'Fakturaadress',
      MUNICIPALITY: 'Kommun',
      NAME: 'Namn',
      NO: 'Nej',
      NOT_APPROVED: 'Ej godkänd',
      NOTES: 'Kommentarer',
      NOTHING_TO_SHOW: 'Det finns inget att visa',
      PAYMENT_DATE: 'Utbetalningsdatum',
      PAYROLL_SCHEDULE: 'Löneschema',
      PAYROLL_SCHEDULES: 'Lönescheman',
      PLACEMENT_INVOICE: 'Faktura',
      PLACEMENT_INVOICE_BASES: 'Fakturaunderlag för placeringar',
      PLACEMENT_SALARY: 'Lön',
      PLACEMENT_SALARY_BASES: 'Lönunderlag för placeringar',
      SALARY: 'Lön',
      SALARY_PER_DAY: 'Dygnskostnad',
      SALARY_PER_MONTH: 'Lön per månad',
      SOCIAL_REFERENCE_ID: 'Referens-ID',
      TITLE: 'Titel',
      TYPE: 'Typ',
      UPDATE_FAILED: 'Uppdateringen misslyckades',
      UPDATED_SUCCESSFULLY: 'Uppdaterad',
      YES: 'Ja',
      YOUR_CHANGES_WILL_BE_IRREVERSIBLE:
        'Dina ändringar kommer att vara oåterkalleliga och kan inte ångras',
      YOUR_CHANGES_WILL_BE_IRREVERSIBLE_AND_NEED_APPROVAL:
        'Dina ändringar kommer att vara oåterkalleliga och kräva nytt godkännande',
    },
  },
};
